import React, { useState, useEffect } from "react";
import { useAuthStore } from "../store/store";

function ReferralTab() {
  const [referralCode, setReferralCode] = useState("");
  const [referralLink, setReferralLink] = useState("");

  const { user, getReferral } = useAuthStore();
  useEffect(() => {
    const fetchInvestmentPlans = async () => {
      try {
        const response = await getReferral(user._id);
        if (response?.data) {
          // console.log(response.data);
          setReferralCode(response?.data?.referralCode);
          setReferralLink(response?.data?.referralLink);
        }
      } catch (error) {
        console.error("Error fetching investment plans:", error);
      }
    };
    fetchInvestmentPlans();
  }, []);

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          Referral Program
        </h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">
          Invite friends and earn rewards
        </p>
      </div>
      <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
        <div className="mb-6">
          <h4 className="text-base font-semibold text-gray-900">
            Your Referral Code
          </h4>
          <div className="mt-2 flex items-center">
            <input
              type="text"
              readOnly
              value={referralCode}
              className="flex-1 block w-full px-3 py-2 sm:text-sm border-gray-300 rounded-md"
            />
            <button
              type="button"
              className="ml-3 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={() => navigator.clipboard.writeText(referralCode)}
            >
              Copy
            </button>
          </div>
        </div>
        <div className="mb-6">
          <h4 className="text-base font-semibold text-gray-900">
            Your Referral Link
          </h4>
          <div className="mt-2 flex items-center">
            <input
              type="text"
              readOnly
              value={referralLink}
              className="flex-1 block w-full px-3 py-2 sm:text-sm border-gray-300 rounded-md"
            />
            <button
              type="button"
              className="ml-3 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={() => navigator.clipboard.writeText(referralLink)}
            >
              Copy
            </button>
          </div>
        </div>
        <div>
          <h4 className="text-base font-semibold text-gray-900">
            Share on Social Media
          </h4>
          <div className="mt-2 flex space-x-4">
            <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
              Share on Twitter
            </button>
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
              Share on Facebook
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferralTab;
